function DRUGSTORE(state) {
    return state.drugstore;
};

export {
    DRUGSTORE,
};